import LinearProgress from "@mui/material/LinearProgress";
import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "../register/auth-shell";
import "../register/auth-ui.css";
import { showOrToast } from "../shared_modules/ui/components/atoms/or-toast/or-toast";
import { useAclRepository } from "./useAclRepository";

export default function AclValidator() {
  const { validateAcl } = useAclRepository();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      validate();
    } else {
      navigate("/login");
    }
  }, [token]);

  const validate = async () => {
    try {
      let result = await validateAcl({
        token: token,
      });

      if (result) {
        showOrToast("¡Solicitud Validada!");
        navigate("/login");
      } else {
        showOrToast("No hemos podido validar la solicitud", { type: "error" });
        navigate("/login");
      }
    } catch (error) {
      showOrToast("Error al validar la solicitud", { type: "error" });
      navigate("/login");
    }
  };

  return (
    <AuthShell
      title="Validando solicitud"
      subtitle="Estamos procesando tu solicitud de acceso, por favor espera un momento."
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <div className="or-auth-loading">
        <LinearProgress />
      </div>
    </AuthShell>
  );
}
